import { render } from "./BBreadcrumb.vue?vue&type=template&id=8a326f3e"
import script from "./BBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__